import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { roomsChange } from '../../actions';
import { CheckboxGroup } from '../../components/CheckboxGroup';
import { getRooms } from '../../selectors';
import { ERooms } from '../../types/filters';
import { TThunkDispatch } from '../../types/redux/thunk';
import { setQueryParameter } from '../../utils';
import { roomsOptions } from './config';

export function RoomsCheckbox() {
  const dispatch: TThunkDispatch = useDispatch();
  const rooms = useSelector(getRooms);

  const handleRoomsChange = React.useCallback(
    (event: React.SyntheticEvent, rooms: ERooms[]) => {
      dispatch(roomsChange(rooms));
      setQueryParameter('rooms', rooms.join(','));
    },
    [dispatch],
  );

  return <CheckboxGroup title="Количество комнат" options={roomsOptions} value={rooms} onChange={handleRoomsChange} />;
}
